import { t } from 'i18next'

export const TERMS_OF_SERVICE_TITLE = t('termsOfService.title')
